// this mixin provides update and remove methodes for trainings elements based on uuid from url
import notification from '../../notification'

export default {
    data () {
        return {
            trainingElements: null,
            attachedTrainingElements: [],
        }
    },
    computed:{
      trainingElementsOrder() {
        let uuids = []
        this.attachedTrainingElements.map(({uuid}) => { uuids.push(uuid) } )
        return uuids
      }
    },
    mounted (){
      this.getCurrentTrainingElements()
      this.getTrainingElements()
    },
    methods: {
        getTrainingElements(){
            this.$vs.loading()
            const uuid = this.$route.params.uuid
            this.$store.dispatch('trainings/getTrainingElements', uuid)
              .then((response) => {
                const elements = []
                Object.entries(response.data).forEach(([key, value]) => {
                  elements.push(value)
                })
                this.trainingElements = elements
              })
              .catch(error => {
                this.$vs.notify(notification.error(error.message))
              })
            .finally(() => {
              this.$vs.loading.close()
            })
        },
      attachTrainingElement(elementUuid){
            this.$vs.loading()
            const payload = {
              uuid: this.$route.params.uuid,
              elementUuid: elementUuid
            }
            this.$store.dispatch('trainings/attachTrainingElement', payload)
              .then(() => {
                this.$vs.notify(notification.success('Element został przypisany do tego szkolenia'))
              })
              .catch(error => {
                this.$vs.notify(notification.error(error.message))
              })
            .finally(() => {
              this.$vs.loading.close()
            })
        },
        detachTrainingElement(elementUuid){
            this.$vs.loading()
            const payload = {
              uuid: this.$route.params.uuid,
              elementUuid: elementUuid
            }
            this.$store.dispatch('trainings/detachTrainingElement', payload)
              .then(() => {
                this.$vs.notify(notification.success('Element został usunięty z tego szkolenia'))
              })
              .catch(error => {
                this.$vs.notify(notification.error(error.message))
              })
            .finally(() => {
              this.$vs.loading.close()
            })
        },
        orderTrainingElements(){
            this.$vs.loading()
            const uuid = this.$route.params.uuid
            const payload = {
              trainingElements: this.trainingElementsOrder
            }
            this.$store.dispatch('trainings/orderTrainingElements', {
              uuid: uuid,
              order: payload
            })
              .then(() => {
                this.$vs.notify(notification.success('Kolejność elementów została zmieniona'))
              })
              .catch(error => {
                this.$vs.notify(notification.error(error.message))
              })
            .finally(() => {
              this.$vs.loading.close()
            })
        },
      getCurrentTrainingElements() {
        this.$vs.loading()
        const uuid = this.$route.params.uuid
        this.$store.dispatch('trainings/getTraining', uuid)
          .then(response => {
            if(response.data.data.elements)
            this.attachedTrainingElements = response.data.data.elements
          })
          .catch(error => {
            this.$vs.notify(notification.error(error.message))
          })
          .finally(() => {
            this.$vs.loading.close()
          })
      },

},
}
